import script from "./AcceleratedPaymentMF.vue?vue&type=script&lang=ts&setup=true"
export * from "./AcceleratedPaymentMF.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__